import React from 'react';
import styled from 'styled-components';

import AgePicker from './AgePicker';
import SheetSelect from './SheetSelect';
import ColumnSwitch from './ColumnSwitch';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Label = styled.div``;

const InputWrapper = styled.div`
  max-width: 200px;
`;

export default function ChartControls() {
  return (
    <div>
      {/* <Wrapper>
        <Label>Alter in Jahren</Label>
        <InputWrapper>
          <AgePicker />
        </InputWrapper>
      </Wrapper> */}
      <Wrapper>
        <SheetSelect side="left" />
        <SheetSelect side="right" />
      </Wrapper>
      <Wrapper>
        <ColumnSwitch side="left" />
        <ColumnSwitch side="right" />
      </Wrapper>
    </div>
  );
}
